import { render, staticRenderFns } from "./WinnerDetail.vue?vue&type=template&id=b6d0e16e&"
import script from "./WinnerDetail.vue?vue&type=script&lang=js&"
export * from "./WinnerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports